<ion-header translucent="true" *transloco="let t">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button *ngIf="ios" (click)="dismiss()">{{ t('cancel') }}</ion-button>
      <ion-button *ngIf="!ios" (click)="selectAll(true)"
        >{{ t('selectAll') }}</ion-button
      >

      <ion-button *ngIf="!ios" (click)="selectAll(false)"
        >{{ t('clear') }}</ion-button
      >
    </ion-buttons>

    <ion-title> {{ t('filterColumns') }} </ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="applyFilters()" strong>{{ t('done') }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      animated
      (ionChange)="getFilterValue($event)"
      (keydown.enter)="searchEnter($event)"
      [placeholder]="t('search')"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content *transloco="let t">
  <ion-list [lines]="ios ? 'inset' : 'full'">
    <cdk-virtual-scroll-viewport itemSize="48" style="height: 100%">
      <ion-item
        *cdkVirtualFor="let item of sortedOptionsArray"
        [attr.col]="item.title"
        (click)="filtersChanged(item)"
      >
        <ion-label>{{item.title}}</ion-label>
        <div class="telus-item-label">
          <p class="form-input-item">
            <span>
              <input
                type="checkbox"
                class="telus-checkbox-input"
                color="secondary"
                (ngModelChange)="filtersChanged(item)"
                [(ngModel)]="filters.dict[columnName].dict[item.title].checked"
              />
            </span>
          </p>
        </div>
      </ion-item>
    </cdk-virtual-scroll-viewport>
  </ion-list>
</ion-content>

<ion-footer translucent="true" *ngIf="ios">
  <ion-toolbar *transloco="let t">
    <ion-buttons slot="start">
      <ion-button (click)="selectAll(false)">{{ t('deselectAll') }}</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="selectAll(true)">{{ t('selectAll') }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
